import { render, staticRenderFns } from "./EditCompound.vue?vue&type=template&id=2c4b4d80&scoped=true&"
import script from "./EditCompound.vue?vue&type=script&lang=js&"
export * from "./EditCompound.vue?vue&type=script&lang=js&"
import style0 from "./EditCompound.vue?vue&type=style&index=0&id=2c4b4d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b4d80",
  null
  
)

export default component.exports